import '../styles/Home.css';
import gh from "../Assets/Game View/Gameplay-Home.png";
import React from "react";


// description images
const descriptionImages = {
    about: require("../Assets/Images/Description Images/about.png"),
    person: require("../Assets/Images/Description Images/person.png"),
    customize: require("../Assets/Images/Description Images/customize.png"),
    stream: require("../Assets/Images/Description Images/stream.png"),
    ragstoriches: require("../Assets/Images/Description Images/ragstoriches.png"),
    divisions: require("../Assets/Images/Description Images/divisions.png"),
    collabs: require("../Assets/Images/Description Images/collabs.png"),
};

const gameScreenshots_UI = {
    blank: require("../Assets/Website Pack/UI/Blank Fullscreen.png"),
    comingsoon: require("../Assets/Website Pack/UI/Coming Soon.png"),
    healthsafety: require("../Assets/Website Pack/UI/Health And Safety.png"),
    leaderboard: require("../Assets/Website Pack/UI/Leaderboard.png"),
};

const gameScreenshots_game = {
    blockpreview: require("../Assets/Website Pack/Gameplay/Hold Note Screenshot.png"),
    tutorial: require("../Assets/Website Pack/Gameplay/Tutorial Screenshot.png"),
    somanyshaders: require("../Assets/Website Pack/Gameplay/So Many Shaders.gif"),
};

const otherAssets = {
    square: require("../Assets/Website Pack/Square.png"),
    steamBig: require("../Assets/Website Pack/Steam Wallpaper.jpg"),
};

function Home() {
    // Function to handle arrow click event
    const handleArrowClick = () => {
        console.log("Arrow clicked!");
        // Example: Scroll to "about-section"
        document.getElementById("about").scrollIntoView({ behavior: "smooth"});
    };

    return (
        <div>
            <div className="image-container">
                <div className="goResponsive homescreen-image">
                    <img src={gh} alt=""/>
                </div>
            </div>

            <div className="goResponsive-pos text-container">
                <p style={{color: 'white', fontSize: '3.45vh'}}>
                    ABOUT POLY BEATS
                    <div className="goResponsive-pos arrow" onClick={handleArrowClick}></div>
                </p>
            </div>

            <div id="About Poly Beats">
                <div className="about-frames-container">
                    {/* A New Contender To The Rhythm Game Space */}
                    <div className="about-frame">
                        <div id="about">
                            <img src={descriptionImages.about} alt="About Poly Beats"/>
                            <p className="no-wrap">A NEW CONTENDER TO THE RHYTHM GAME SPACE.</p>
                        </div>

                        <div className="about-text-container">
                <span className="normal-text">
                    Welcome to Poly Beats, the 5K Rhythm Game that's all about proving absolutely nothing!
                    <br/>Our goal? Simply to rival big games like Quaver.
                    <br/><br/>Think it's tough? Think again, because this is hands down the coolest 5K rhythm game around.
                    <br/><br/>
                    <span className="small-text">maybe. sorta. kinda. potentially. you’re the judge here.</span>
                </span>

                            <img
                                src={gameScreenshots_UI.healthsafety}
                                alt="Health and Safety"
                                className="health-safety-image"
                            />
                        </div>

                        <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                    </div>

                    {/* What Even Is A "5K Rhythm Game"? */}
                    <div className="about-frame">
                        <div id="What Even Is A 5K Rhythm Game">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <p className="no-wrap">WHAT EVEN IS A "5K RHYTHM GAME"?</p>
                                        <img style={{height: "75px", width: "75px"}} src={descriptionImages.person}
                                             alt="Person"/>
                                    </div>

                                    <div className="about-text-container">
                                        <img
                                            src={gameScreenshots_game.tutorial}
                                            alt="Chewtorial"
                                            className="health-safety-image"
                                        />
                                        <span className="normal-text">
                    You may be asking.
                    <br/><br/> Well, a rhythm game is a game where you do something to the beat, or, <i>rhythm</i> of the music, your goal is to stay as parallel (similar) as possible to the timing.
<br/><br/> In our case, our game is 5K - which means you have 5 inputs that could be tested for your accuracy at any given moment in a song.
                </span>


                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Customize... Everything? */}
                    <div className="about-frame">
                        <div id="Customize Everything">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <img src={descriptionImages.customize}
                                             alt="Workshop"/>
                                        <p className="no-wrap">CUSTOMIZE... EVERYTHING?!</p>
                                    </div>

                                    <div className="about-text-container">

                                        <span className="normal-text">
                    We were all about making Poly Beats tailor to you from the start.
                                            <br/><br/>Personalize your experience with custom keybinds, maps, colors, and note effects.
                                            <br/><br/>But we're not stopping there – dive into the world of Steam Workshop, where players worldwide can effortlessly share and access custom maps and themes.
                </span>
                                        <img
                                            src={otherAssets.steamBig}
                                            alt="Steam Big"
                                            className="health-safety-image"
                                        />

                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Decorations In Every Official Level */}
                    <div className="about-frame">
                        <div id="Decorations In Every Official Level">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <p className="no-wrap">DECORATIONS IN EVERY OFFICIAL LEVEL.</p>
                                        <img src={descriptionImages.stream}
                                             alt="stream"/>
                                    </div>

                                    <div className="about-text-container">
                                        <img
                                            src={gameScreenshots_game.somanyshaders}
                                            alt="SMS"
                                            className="health-safety-image"
                                        />
                                        <span className="normal-text">
                    For our casual players, we've got something special – Stream! Our in-house decoration system & runtime option, that lets map creators go wild with decorations, like shapes, light rays, and custom shaders!
<br/><br/>
Plus, it's super easy with our in-game Decoration Editor. Just lay down the original Chart-Map (which is where all the notes to your level are stored), and we're good to go!</span>


                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Innovative Gamemodes */}
                    <div className="about-frame">
                        <div id="Innovative Gamemodes">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <img src={descriptionImages.ragstoriches}
                                             alt="Rags to Riches"/>
                                        <p className="no-wrap">INNOVATIVE GAMEMODES.</p>
                                    </div>

                                    <div className="about-text-container">

                                        <span className="normal-text">
                    For you more competitive players, check out 'Rags To Riches'  - Poly Beats’ asynchronous multiplayer mode!
<br/><br/>
 Receive songs from other players and aim to outdo the previous player within a set time. Climb the Poly Beats League ladder and earn those Skill Points!</span>
                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Ranked Divisions */}
                    <div className="about-frame">
                        <div id="Ranked Divisions">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <p className="no-wrap">RANKED DIVISIONS.</p>
                                        <img src={descriptionImages.divisions}
                                             alt="Divisions"/>
                                    </div>

                                    <div className="about-text-container">
                                        <img
                                            src={gameScreenshots_UI.leaderboard}
                                            alt="leaderboard"
                                            className="health-safety-image"
                                        />
                                        <span className="normal-text">
                   For you more competitive players, check out 'Rags To Riches'  - Poly Beats’ asynchronous multiplayer mode!
<br/><br/>
 Receive songs from other players and aim to outdo the previous player within a set time. Climb the Poly Beats League ladder and earn those Skill Points!</span>
                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tune Packs, Collabs, More Content */}
                    <div className="about-frame">
                        <div id="Tune Packs, Collabs, More Content">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <img src={descriptionImages.collabs}
                                             alt="Collabs"/>
                                        <p className="no-wrap">TUNE PACKS, COLLABS, MORE CONTENT!</p>
                                    </div>

                                    <div className="about-text-container">

                                        <span className="normal-text">
                                            We want to actually consistently give songs to our community, <i>unlike another game... where you rely on only the community after the tutorial. </i>
                                            <br/><br/> We intend to make official OSTs for all our players who regularly want new challenges, alongside a couple collabs with artists both over and underground here and there. </span>
                                        <img
                                            src={gameScreenshots_game.blockpreview}
                                            alt="Blocks"
                                            className="health-safety-image"
                                        />

                                    </div>

                                    <img className="divider" src={otherAssets.square}
                                         alt="Divider"/> {/* Divider image */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Poly Beats Is FREE! */}
                    <div className="about-frame">
                        <div id="Poly Beats Is Free">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <div id="about">
                                        <p className="title">POLY BEATS IS <span style={{color: '#51FF00'}}>FREE</span>!
                                        </p>
                                    </div>

                                    <div className="about-text-container">
                                        <span className="normal-text">
                        Just to note, if all that other stuff, somehow, didn’t interest you.
                        <br/><br/> Enjoy base game content, customizations, and maps without spending a dime - you deserve a nice game at no price.
                    </span>

                                    </div>
                                </div>
                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>

                    {/* Get It Now, Fool. */}
                    <div className="about-frame">
                        <div id="Get It Now, Fool">
                            <div className="about-frames-container">
                                <div className="about-frame">
                                    <br/>
                                    <div id="about">

                                        <p style={{color: '#FF6394'}} className="no-wrap">GET IT NOW, FOOL.</p>

                                    </div>

                                    <div className="about-text-container">
                                       <span className="normal-text">
                    Thanks for reading about our game! If you made it this far, I'm sure you wanna play… so what are you waiting for?
                                           <br/><br/> Wishlist this thing, and we'll catch you on release day! :)
                </span>

                                    </div>

                                    <br/><br/>
                                    <iframe src="https://store.steampowered.com/widget/2734590/" frameBorder="0"
                                            width="720" height="200"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Home;